import { type FC } from "react";

import { cx } from "@emotion/css";
import { RocketIcon, Sizes } from "@snapchat/snap-design-system-icons";

import { useGameLensState } from "../../../../lens/hooks";

import styles from "./GameLensBadge.module.css";
import { LensRowBadge } from "./LensRowBadge";
import { badgeDisabled } from "./LensRowBadge.styles";
import { BadgeGameLens } from "./messages.generated";

import { Flexbox } from "src/app/shared/components";

interface GameLensBadgeProps {
    primaryCategoryId?: string | null;
    isGameUserProvided: boolean;
}

export const GameLensBadge: FC<GameLensBadgeProps> = ({ primaryCategoryId, isGameUserProvided }) => {
    const gameLensState = useGameLensState({
        primaryCategoryId,
        isGameUserProvided,
    });

    if (!gameLensState) {
        return null;
    }

    return (
        <LensRowBadge dataTestId="lens-row-game-badge" className={cx(badgeDisabled, styles.badge)}>
            <Flexbox alignItems="center" gap="8px">
                <RocketIcon data-testid="lens-row-game-badge-icon" className={styles.icon} size={Sizes.Small} />
                <span>
                    <BadgeGameLens />
                </span>
            </Flexbox>
        </LensRowBadge>
    );
};
